import { render, staticRenderFns } from "./RedirectSelectedType.vue?vue&type=template&id=6c5c1a7c&lang=html&"
import script from "./RedirectSelectedType.vue?vue&type=script&lang=js&"
export * from "./RedirectSelectedType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports